class PaymentFlowPresenter {
    constructor(usecase) {
        this.usecase = usecase;
    }
    tradePayment(req) {
        return new Promise((resolve, reject) => {
            this.usecase.tradePayment.execute({
                onSuccess: (data) => resolve(data),
                onError: (error) => reject(error),
            }, req);
        });
    }
    paymentGateway(req) {
        return new Promise((resolve, reject) => {
            this.usecase.paymentGateway.execute({
                onSuccess: (data) => resolve(data.data),
                onError: (error) => reject(error),
            }, req);
        });
    }
    getPayBankDetails() {
        return new Promise((resolve, reject) => {
            this.usecase.getPayBankDetails.execute({
                onSuccess: (data) => resolve(data.data),
                onError: (error) => reject(error),
            }, null);
        });
    }
    getMfPaymentStatus(req) {
        return new Promise((resolve, reject) => {
            this.usecase.getmfPaymentStatus.execute({
                onSuccess: (data) => resolve(data),
                onError: (error) => reject(error),
            }, req);
        });
    }
}
export default PaymentFlowPresenter;
